import React from 'react';
import IngresosUI from '../../Admin/Ingresos/IngresosUI';

const IngresosContabilidadUI = () => {
  return <IngresosUI apiBasePath="/api/contabilidad" allowEditDelete={false} />;
};

export default IngresosContabilidadUI;